import { combineReducers } from 'redux';

import contentsSiteReducer from './contents-site-reducer';
import rootSiteReducer from './root-site-reducer';
import siteReducer from './site-reducer';
import authReducer from './auth-reducer';
import toastReducer from './toast-reducer';
import expertProfileReducer from './expert-profile-reducer';
import userReducer from './user-reducer';
import redirectToReducer from './redirect-to-reducer';
import accountSettingsReducer from './account-settings-reducer';
import expertSettingsReducer from './expert-settings-reducer';
import expertVolunteeringsReducer from './expert-volunteerings-reducer';
import implicitAuthReducer from './implicit-auth-reducer';
import loadingApiReducer from './loading-api-reducer';
import detectingAuthenticatedUserReducer from './detecting-authenticated-user-reducer';
import contentsSystemReducer from './contents-system-reducer';
import langReducer from './lang-reducer';
import customPagesReducer from './custom-pages-reducer';
import adminAuthReducer from './admin/admin-auth-reducer';
import customPageReducer from './custom-page-reducer';
import designPathsReducer from './design-paths-reducer';
import sidebarMenuReducer from './sidebar-menu-reducer';
import adminUXReducer from './admin/admin-ux-reducer';
import defaultBlockContentsReducer from './admin/default-block-contents-reducer';
import userNotificationConfigsReducer from './user-notification-configs-reducer';
import auth0Reducer from './auth0-reducer';
import adminPageReducer from './admin/admin-page-reducer';
import designsOverlayReducer from './designs-overlay-reducer';

export default combineReducers({
  rootSite: rootSiteReducer,
  site: siteReducer,
  contentsSite: contentsSiteReducer,
  auth: authReducer,
  toast: toastReducer,
  expertProfile: expertProfileReducer,
  user: userReducer,
  redirectTo: redirectToReducer,
  accountSettings: accountSettingsReducer,
  expertSettings: expertSettingsReducer,
  expertVolunteerings: expertVolunteeringsReducer,
  implicitAuth: implicitAuthReducer,
  loadingApi: loadingApiReducer,
  detectingAuthenticatedUser: detectingAuthenticatedUserReducer,
  contentsSystem: contentsSystemReducer,
  lang: langReducer,
  customPages: customPagesReducer,
  adminAuth: adminAuthReducer,
  customPage: customPageReducer,
  designPaths: designPathsReducer,
  sidebarMenu: sidebarMenuReducer,
  userNotificationConfigs: userNotificationConfigsReducer,
  designsOverlay: designsOverlayReducer,
  adminUX: adminUXReducer,
  adminDefaultBlockContents: defaultBlockContentsReducer,
  auth0: auth0Reducer,
  adminPage: adminPageReducer,
});
